import { AppState } from '@app/ngrx/app-state/app-state';
import { createSelector } from '@ngrx/store';

export const getFiltersState = (state: AppState) => state.filters;

export const getCountFilters = createSelector(getFiltersState, (state) => state.filtersCount);

